import { IRegistration } from '../../../api/workshopRegistrations';
import { format, parseISO } from 'date-fns';
import { CheckBox } from '@wot/components';
import { TableRowItemData } from '../../../components/Table';

export default function TableRowItem({
  registration,
  selected,
  onSelect
}: {
  registration: IRegistration;
  selected: boolean;
  onSelect: (id: string, checked: boolean) => void;
}) {
  return (
    <>
      <td className="w-12 px-4 py-2" onClick={(e) => e.stopPropagation()}>
        <CheckBox defaultValue={selected} onChange={(checked) => onSelect(registration._id, checked)} />
      </td>
      <TableRowItemData text={format(parseISO(registration.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={registration.studentName || '-'} />
      <TableRowItemData text={registration.parentName || '-'} />
      <TableRowItemData text={registration.email || '-'} />
      <TableRowItemData text={registration.phone || '-'} />
      <TableRowItemData text={registration.workshop || '-'} />
      <TableRowItemData text={registration.className || '-'} />
      <TableRowItemData text={registration.paidAmount ? `${registration.currency || ''} ${registration.paidAmount}` : '-'} />
    </>
  );
}
